import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { GridComponent } from "@app/modules/shared/components/grid/grid.component";
import { UtilService } from "@app/modules/shared/services/util.service";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { CustomerFormComponent } from "@dashboard/modules/shipping-management/customer/components/customer-form/customer-form.component";

@Component({
  selector: "kl-customer-list",
  templateUrl: "./customer-list.component.html",
  styleUrls: ["./customer-list.component.scss"],
})
export class CustomerListComponent implements OnInit, AfterViewInit {
  templateContext: any;
  @Input() tabId: string;
  @Input() modalId: string;
  filterSelectItems = [
    {
      name: "code",
      description: "code",
    },
    {
      name: "description",
      description: "title",
    },
  ];
  filterObject: any;
  @Input() mode: string;
  @Input() dblSelect = false;
  @ViewChild(forwardRef(() => GridComponent), { static: true })
  private gridComponent: GridComponent;
  dropdownActions = [
    {
      icon: "fal fa-copy",
      slug: "copy",
      method: (cell) => {
        if (this.utilService.isShow(this.tabId + ".006")) {
          this.gridComponent.alertShow = false;
          this.klLoadingService.show("loading");
          this.apiService.getDataById("customer", cell.item.id).subscribe(
            (response) => {
              if (response === undefined) {
                this.handleError("error_data");
              } else {
                const copyData = UtilService.deepCopy(response);
                const tabConfig = <TabConfig>{
                  id: "customerCopy" + response.id,
                  title: "customer",
                  childTemplate: <DynamicComponent>{
                    mode: "copy",
                    tabId: "customerCopy" + response.id,
                    template: CustomerFormComponent,
                    dataContext: copyData,
                    service: "customer",
                    isReadOnly: false,
                  },
                  isCloseable: true,
                };
                this.explorerService.openTab(tabConfig);
              }
            },
            (error) => this.handleError(error)
          );
        } else {
          this.handleError("not_authorized_to_perform_this_operation");
        }
      },
    },
  ];

  constructor(
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private klLoadingService: KlLoadingService
  ) {}

  ngOnInit() {
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
    if (this.templateContext) {
      this.gridComponent.templateContext = this.templateContext;
    }
  }

  ngAfterViewInit(): void {
    if (this.dropdownActions.length > 0) {
      this.gridComponent.actions = this.dropdownActions;
    }
    if (this.mode) {
      this.gridComponent.mode = this.mode;
    }
  }

  handleError(error) {
    this.klLoadingService.hide();
    this.gridComponent.alertMessage = this.utilService.alertErrorMessage(error);
    this.gridComponent.alertType = "error";
    this.gridComponent.alertShow = true;
    this.gridComponent.changeDetector.markForCheck();
  }
}
